import { gql } from '@apollo/client';

export const GetCurrentUserSubscriptionsQuery = gql`
  query GetMySubscriptions {
    getCurrentUserSubscriptionsStripe
  }
`;
